import P2Medium from 'components/typography/P2Medium';
import { RevisionTemplateRow } from 'components/tables/data/revision-template/types';
import { Flex, Tooltip, useMantineTheme } from '@mantine/core';
import BadgeDeleted from 'components/Badge';
import { IconTarget } from '@tabler/icons-react';

/**
 * Column for the revision template name.
 */
export default function RevisionTemplateNameColumn({
  data: { name, status, singleDeviceOnly },
}: {
  data: RevisionTemplateRow;
}) {
  const theme = useMantineTheme();
  const opacity = status ? 1 : 0.6;

  return (
    <Flex gap={10} align="center">
      {!status && <BadgeDeleted text="Vyradené" />}
      <P2Medium color="gray.8" style={{ opacity }}>
        {name}
      </P2Medium>
      {singleDeviceOnly && (
        <Tooltip label="Šablóna je určená iba pre jedno zariadenie">
          <IconTarget size={20} color={theme.colors.red[8]} style={{ opacity }} />
        </Tooltip>
      )}
    </Flex>
  );
}
